import React, { useEffect, useState } from "react";
import {
  PRIYOJNA_IMG,
  USER_APPLICATOIN_ICON,
  USER_KENDRA_ICON,
  USER_MINI_LOGO,
  USER_PMBI_LOGO,
} from "../../../../utils/app-image-contant";
import { Link} from "react-router-dom";
import { ROUTES } from "../../../../hooks/routes/url-constant";
import { useSelector } from "react-redux";

const Navbar = () => {
  const { value } = useSelector((state) => state?.loggedUser);
  const [menuData, setMenuData] = useState([
    {
      name: "APPLY FOR KENDRA",
      path: ROUTES?.UserProfile?.APPLICATION_FORM,
      active: !value?.applicationExist ? true : false,
      imageUrl: USER_KENDRA_ICON,
    },
    {
      name: "MY APPLICATION",
      path: ROUTES?.UserProfile?.MY_APPLICATION,
      active: value?.applicationExist? true : false,
      imageUrl: USER_APPLICATOIN_ICON,
    },
   
  ]);

  
  useEffect(() => {
    if (localStorage.getItem("nMenuData")) {
      setMenuData(JSON?.parse(localStorage.getItem("nMenuData")));
    } else {
      let data = menuData
      setMenuData(data)
    }
  }, []);

  const handleClickMenu = (item, idx) => {
    let nMenuData = menuData.map((d, i) => {
      return { ...d, active: i === idx || false };
    });
    localStorage.setItem("nMenuData", JSON.stringify(nMenuData));
    setMenuData(nMenuData);
  };



  return (
    <>
    <div className="navbarwebsiteside">
    <nav className="sidebar active-large-sidebar" id="side-bar-show">
        <div className="logo d-flex justify-content-between">
          <Link
            className="large_logo d-flex justify-content-center align-items-center"
            to={ROUTES.HOME}
          >
            <img src={PRIYOJNA_IMG} alt="" />
            <img src={USER_PMBI_LOGO} alt="" />
          </Link>
          <Link className="small_logo" to={ROUTES.HOME}>
            <img src={USER_MINI_LOGO} alt />
          </Link>
          <div className="sidebar_close_icon d-lg-none">
            <i className="ti-close" id="ti-cross-button"></i>
          </div>
        </div>
        <div className="navbar-bg">
          <ul id="sidebar_menu">
            {menuData?.map((item, index) => {
              return (
                <li key={item.id}
                  
                  className={item?.active ? "active" : ""}
                  id="listMenu"
                  onClick={(e) => handleClickMenu(item, index)}
                >
                  <Link to={item?.path}>
                    <div className="nav_icon_small">

                      <img
                        src={item?.imageUrl}
                        alt="application-icon"
                      />
                    </div>
                    <div className="nav_title">
                      <span>{item?.name}</span>
                    </div>

                  </Link>
                </li>
              );
            })}

          </ul>
        </div>
      </nav>
    </div>
     
    </>
  );
};

export default Navbar;
